import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Button } from '@/components/ui/Button';
import { useMySubscription } from '@/api/queries/subscription';
import { formatDate } from '@/utils/date';
import { useLocale } from '@/hooks/useLocale';
import { paths } from '@/routes/paths';

interface ResultProps {
  variant: 'success' | 'error';
}

export function SubscribeResultPage({ variant }: ResultProps): JSX.Element {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const navigate = useNavigate();
  const sub = useMySubscription();

  const isOk = variant === 'success';

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('subscribe.title')} />
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            gap: 16,
          }}
        >
          <div style={{ fontSize: 56 }}>{isOk ? '✅' : '⚠️'}</div>
          <h1 style={{ margin: 0 }}>
            {isOk ? t('subscribe.success.title') : t('subscribe.error.title')}
          </h1>
          <p style={{ color: 'var(--color-text-on-dark-muted)' }}>
            {isOk
              ? t('subscribe.success.body', {
                  date: sub.data ? formatDate(sub.data.current_period_end, locale) : '—',
                })
              : t('subscribe.error.body')}
          </p>
        </div>
        <Button
          block
          size="lg"
          variant="inverted"
          onClick={() => navigate(isOk ? paths.wallet : paths.subscribePlans, { replace: true })}
        >
          {isOk ? t('subscribe.success.cta') : t('subscribe.error.cta')}
        </Button>
      </PageContainer>
    </AppShell>
  );
}
